import { Col, Row, Form, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import { ShowBoxData } from "./HeadDetail";
import { Pagination } from "./DetailEquip";
import { useRef, useState } from "react";
import { initializeSetOption } from "../../utils/InitializeSetDefault";
import { getQueryString } from "../../utils/Query";
import TechnicianReceiveService from "../../services/technicianreceive.service";
import { getServiceRequest } from "../../commons/ServiceRequest";
import { useAlert } from "../../context/AlertContext";
import ServiceRequestService from "../../services/servicerequest.service";
import { useLoading } from "../../context/LoadingContext";
import InputSearch from "../InputSearhComponent";

export default function HeadData({ defaultData, searchCallback, allData, setCurrentPage, currentPage }) {
  const searchBtnRef = useRef(null);
  const clearBtnRef = useRef(null);
  const fieldClassName = { inputRow: "justify-content-end", actionButton: "w-auto py-2" }
  const [WorkNo, setWorkNo] = useState([])
  const { showAlert } = useAlert();
  const [numIndex, setNumIndex] = useState(1);
  const [validated, setValidated] = useState(false);
  const { loading, setLoading } = useLoading();

  const field = [
    {
      name: "job_type_id",
      label: "ประเภทงาน",
      size: "1_5",
      noneAsync: true,
      filterBy: ["Job_Type_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Job_Type_Name",
        dataset: defaultData?.job_type
      }),
      classNames: { label: "mb-3" },
    },
    {
      name: "no",
      label: "คร้งที่",
      type: "text",
      disabled: true,
      size: "1_5",
      value: allData[currentPage]?.no,
      classNames: { label: "mb-3" },
    },
    {
      name: "start",
      label: "วันที่ปฏิบัติงาน",
      type: "date",
      size: 3,
      classNames: { label: "mb-3" },
    },
    {
      name: "seq_no",
      label: "เลขที่ใบสั่งงาน",
      size: 3,
      filterBy: ["seq_no"],
      required: true,
      options: initializeSetOption({
        key: "seq_no",
        label: "seq_no",
        dataset: WorkNo
      }),
      queryService: (query, value) => {
        const q = getQueryString({ seq_no: value, limit: 100, page: 1 })
        getServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: ServiceRequestService.getSeqNoOperational(q),
          callback: (array) => {
            const newArray = array.data?.map(arr => ({
              seq_no: arr.seqJob.seqNo
            }))
            setWorkNo(newArray)
          }
        });
      }
    },
    {
      name: "Ticket",
      label: "หมายเลข TicKet ลูกค้า",
      type: "text",
      disabled: true,
      size: 3,
      value: allData[currentPage]?.Ticket,
      classNames: { label: "mb-3" },
    },
    {
      name: "contract_no",
      label: "สัญญาเลขที่",
      type: "text",
      disabled: true,
      size: "3",
      value: allData[currentPage]?.SeqOthersJob?.InformOtherJob?.Contract_No,
      classNames: { label: "mb-3" },
    },
    {
      name: "contract_type",
      label: "ประเภทสัญญา",
      type: "text",
      disabled: true,
      size: 3,
      classNames: { label: "mb-3" }
    },
    {
      name: "start_contract",
      label: "วันที่เริ่มสัญญา",
      type: "date",
      disabled: true,
      size: "1_5"

    },
    {
      name: "end_contract",
      label: "วันสิ้นสุดสัญญา",
      type: "date",
      disabled: true,
      size: "1_5"

    },
    {
      name: "tect_mas_name",
      label: "ช่างปฏิบัติงาน",
      type: "text",
      disabled: true,
      size: 3,
      classNames: { label: "mb-3" },
    },
    {
      name: "cus_code",
      label: "รหัสลูกค้า/สาขา",
      type: "text",
      disabled: true,
      size: 3,
      value: allData[currentPage]?.SeqOthersJob?.InformOtherJob?.Customer.Cus_Code,
      classNames: { label: "mb-3" },
    },
    {
      name: "cus_no",
      label: "เลขที่สาขา",
      type: "text",
      disabled: true,
      size: "1_5",
      value: allData[currentPage]?.SeqOthersJob?.InformOtherJob?.Customer.Cus_NumBranch,
      classNames: { label: "mb-3" },
    },
    {
      name: "cus_name",
      label: "ชื่อลูกค้า/สาขา",
      type: "text",
      disabled: true,
      size: "4_5",
      value: allData[currentPage]?.SeqOthersJob?.InformOtherJob?.Customer.Cus_Name,
      classNames: { label: "mb-3" },
    },
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      type: "text",
      disabled: true,
      size: 3,
      value: allData[currentPage]?.Technician?.Tech_Mas_Name,
      classNames: { label: "mb-3" },
    },
    {
      name: "sq",
      label: "sq.",
      type: "text",
      disabled: true,
      size: "1_5",
      value: allData[currentPage]?.Sq
    },
    {
      name: "name",
      label: "ชื่อสินค้า",
      type: "text",
      disabled: true,
      size: "4_5",
      value: allData[currentPage]?.Item_Name,
      classNames: { label: "mb-3" },
    },
    {
      name: "equip_no",
      label: "หมายเลขเครื่อง",
      type: "text",
      disabled: true,
      size: 3,
      value: allData[currentPage]?.Item_No,
      classNames: { label: "mb-3" },
    },
    {
      name: "project_no",
      label: "เลขโครงการ",
      type: "text",
      disabled: true,
      size: 3,
      value: allData[currentPage]?.SeqOthersJob?.InformOtherJob?.Project_No,
      classNames: { label: "mb-3" },
    },
    {
      name: "start",
      label: "วันที่เข้างาน",
      type: "date",
      disabled: true,
      size: "1_5"
    },
    {
      name: "start",
      label: "เวลา",
      type: "time",
      disabled: true,
      size: "1_5"
    },
    {
      name: "end",
      label: "ถึงวันที่",
      type: "date",
      disabled: true,
      size: "1_5"
    },
    {
      name: "end",
      label: "เวลา",
      type: "time",
      disabled: true,
      size: "1_5"
    },
    {
      name: "location",
      label: "จุดที่ตั้งเครื่องจักร",
      type: "text",
      disabled: true,
      size: 3,
      value: allData[currentPage]?.Location
    },
    {
      name: "status",
      label: "สถานะสาขา",
      type: "text",
      disabled: true,
      size: 3

    }
  ]

  const [searchData, setSearchData] = useState(field);
  const onSearchCallback = (event, name) => {
    event.preventDefault();
    // searchCallback({ seq_no: "INT6704000040"})
    // return
    if (name == "clear") {
      searchCallback()
      setValidated(false)
    } else {
      // searchCallback({
      //   [searchData[0].name]: searchData[0].value || "",
      //   [searchData[2].name]: searchData[2].value || "",
      //   [searchData[3].name]: searchData[3].value || "INFSR670400011"
      // })
      if (searchData?.filter(d => d.name == 'seq_no')?.value) {
        setValidated(false)
        searchCallback({
          [searchData[0].name]: searchData[0].value || "",
          [searchData[2].name]: searchData[2].value || "",
          [searchData[3].name]: searchData[3].value || ""
        })
      } else {
        setValidated(true)
      }
    }
  };

  const handleValidated = (search, type) => {
    // setSearchData(search)
    if (type == "submit") {
      if (search?.seq_no) {
        setValidated(false)
        searchCallback(search)
      } else {
        setValidated(true)
      }
    } else if (search?.seq_no) {
      setValidated(false)
    } else {
      searchCallback()
      setValidated(false)

    }
  };

  return (
    <div>
      <Form noValidate validated={validated}>
        <InputSearch
          field={field}
          inputField={field}
          searchByField={{ name: 'seq_no', queryService: search => console.log(search) }}
          searchCallback={handleValidated}
        // fieldClassName={{ actionButton: "", inputRow: "justify-content-end" }}
        />
        {/* <Col as={Row} className="mb-3">
          <ShowBoxData
            field={field || []}
            data={searchData}
            searchByField={{
              name: 'seq_no',
              queryService: search => fetchSeqNo(search)
            }}
            searchCallback={handleValidated}
          />
        </Col> */}
      </Form>

      <div className="row justify-content-md-center">
       
        <div className="col-md-auto">
          <Pagination
            data={allData || [{}]}
            paginationProps={{
              currentPage: currentPage + 1,
              rowCount: allData.length,
              rowsPerPage: 1,
              onChangePage: page => {
                setCurrentPage(page - 1)
              }
            }}
          />
        </div>

      </div>

    </div>
  )
}

HeadData.propTypes = {
  allData: PropTypes.array,
  defaultData: PropTypes.object,
  searchCallback: PropTypes.func,
  currentPage: PropTypes.number,
  setCurrentPage: PropTypes.func
};